(async () => {
    if (!customElements.get("collection-with-text-swiper")) {  
      class Collectionwithtext extends HTMLElement {
        constructor() {
          super();
          this.swiperElement = this.querySelector("[data-swiper-collection-with-text]");
          this.swiperOptions = {
            loop: false,
            autoplay: false,
            slidesPerView: 1,
            direction: "horizontal",
            keyboard: true,
            threshold: 10,
            breakpoints: {
              320: {
                slidesPerView: 1.5,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 1.5,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              1440: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              },
            },
          };
  
          // Check if we have extra options on the HTML
          if (this && this.dataset && this.dataset.options) {
            const jsonOptions = JSON.parse(this.dataset.options);
            if (jsonOptions) {
              this.swiperOptions = {
                ...this.swiperOptions,
                ...jsonOptions,
              };
            }
          }
  
          // re-init slider when Theme Editor is active
          if (Shopify.designMode && this.swiperInstance) {
            window.addEventListener("shopify:section:load", () => {
              this.swiperInstance.update();
            });
          }
          this.init();
        }
  
        init() {
          this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
          const element = document.querySelector(".header-nav");
          const rect = element.getBoundingClientRect();
          document.querySelectorAll('[data-custom-width]').forEach(item => {
            item.style.marginLeft = `${rect.left}px`;
          })

          window.addEventListener("resize", function() {
              const element = document.querySelector(".header-nav");
              const rect = element.getBoundingClientRect();
              document.querySelectorAll('[data-custom-width]').forEach(item => {
                item.style.marginLeft = `${rect.left}px`;
              })
          });
        }
      }
  
      window.Collectionwithtext = Collectionwithtext;
  
      customElements.define("collection-with-text-swiper", Collectionwithtext);
    }
  })();
  